//@ts-check
//@ts-ignore
import Password from './password.riot';
import { router } from '@riotjs/route';
import { clearPasswordRequest, clearPasswordSuccess, clearPasswordFailure, clearPasswordNextRequest, clearPasswordNextSuccess, clearPasswordNextFailure, setPasswordFailure, setPasswordRequest, setPasswordSuccess } from './password.action';
import { ajaxPost } from '../ajax';
import { connect } from '@/common/lib/riot-redux';
import { openFailedDialog, openInfoDialog } from '@/common/components/kf-dialog';

const mapStateToProps = (state) => ({
  shopId: state.app.shopId,
  web: state.app.web,
  valid: state.app.valid,
  errorMsg: state.app.errMsgPassword
});

const mapDispatchToProps = (dispatch) => ({
  async clearPassword(payload) {
    dispatch(clearPasswordRequest());
    try {
      await ajaxPost('/point', {
        method: 'clearPassword',
        shopId: payload.shopId,
        phone: payload.phone
      });
      dispatch(clearPasswordSuccess());
    } catch (e) {
      dispatch(clearPasswordFailure(e));
    }
  },

  async clearPasswordNext(payload) {
    dispatch(clearPasswordNextRequest());
    try {
      await ajaxPost('/point', {
        method: 'clearPasswordNext',
        phone: payload
      });
      dispatch(clearPasswordNextSuccess());
    } catch (e) {
      dispatch(clearPasswordNextFailure(e));
    }
  },

  async setPassword(payload) {
    dispatch(setPasswordRequest());
    try {
      await ajaxPost('/point', {
        method: 'setPassword',
        shopId: payload.shopId,
        phone: payload.phone,
        password: payload.password
      });
      dispatch(setPasswordSuccess());
      router.push('result');
    } catch (e) {
      dispatch(setPasswordFailure(e));
    }
  },

  openInfoDialog(message) {
    dispatch(openInfoDialog(message));
  },

  openFailedDialog(message) {
    dispatch(openFailedDialog(message));
  }
});

export default connect(Password, mapStateToProps, mapDispatchToProps);